import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    IGetUserCustomPropsAction,
    IGetUserCustomPropsNotStartedAction,
    IGetUserCustomPropsSuccessAction,
    IGetUserCustomPropsErrorAction
} from '../actions/get-user-custom-props';
import { IOpsHubState } from '../state';
import { initialState } from '@telstra-connect/ops-hub/state/initial-state';

export type GetUserCustomPropsAction
    = IGetUserCustomPropsAction
    | IGetUserCustomPropsNotStartedAction
    | IGetUserCustomPropsSuccessAction
    | IGetUserCustomPropsErrorAction;

const init = (state: IOpsHubState, action: GetUserCustomPropsAction) => ({
    ...state,
    userCustomProps: {
        ...initialState.userCustomProps,
        status: action.status
    }
});

const success = (state: IOpsHubState, action: GetUserCustomPropsAction) => {
    return {
        ...state,
        userCustomProps: {
            ...initialState.userCustomProps,
            status: action.status,
            data: (action as IGetUserCustomPropsSuccessAction).data
        }
    };
};

const failure = (state: IOpsHubState, action: GetUserCustomPropsAction) => ({
    ...state,
    userCustomProps: {
        ...initialState.userCustomProps,
        status: action.status,
        error: (action as IGetUserCustomPropsErrorAction).error
    }
});

const reset = (state: IOpsHubState, action: GetUserCustomPropsAction) => {
    return {
        ...state,
        userCustomProps: {
            ...initialState.userCustomProps,
            status: action.status,
            error: null
        }
    };
};

export const getUserCustomPropsReducer = createAsyncReducer(initialState, init, success, failure, reset);
